<template>
    <Layout>
        <v-container style="max-width: 991px">
            <v-card class="elevation-0">
                <v-card-title>
                    <h2>{{ $t_("AVISO_VOUCHER") }}</h2>
                </v-card-title>
                <v-card-text>
                    <p>{{ $t_("MSN_VOUCHER") }}</p>

                    <v-row
                        align="center"
                        justify="center"
                        style="max-width: 400px; margin: 0px auto"
                    >
                        <v-col cols="12">
                            <label required>{{ $t_("LOCALIZADOR") }}</label>
                            <v-text-field
                                v-mask="'XXXXXXXXXXXXXXXX'"
                                @input="localizador = localizador.toUpperCase()"
                                v-model="localizador"
                                type="text"
                                autocapitalize="characters"
                                autocomplete="off"
                                spellcheck="false"
                                :rules="[regraLocalizador]"
                                validate-on-blur
                                dense
                                outlined
                                hide-details="auto"
                                class="mt-3"
                                tabindex="1"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            class="text-left d-flex align-center justify-center"
                        >
                            <div>
                                <vue-recaptcha
                                    ref="recaptcha"
                                    tabindex="10"
                                    theme="red"
                                    size="invisible"
                                    @render="onRecaptchaRender"
                                    @verify="onRecaptchaVerify"
                                    @error="onRecaptchaVerify('')"
                                    :language="$axios.getLocal('lang').data"
                                    v-if="
                                        !$usuario.showModalLogin &&
                                        $config.conf &&
                                        $config.conf.recaptcha_ativo &&
                                        $config.conf.site_key_recaptcha &&
                                        !$sac.recaptchaAtivo
                                    "
                                    class="vue-captcha"
                                    :sitekey="$config.conf.site_key_recaptcha"
                                    :loadRecaptchaScript="true"
                                ></vue-recaptcha>
                            </div>
                        </v-col>
                        <v-col
                            cols="12"
                            class="d-flex align-center justify-center text-center"
                        >
                            <v-btn
                                x-large
                                tabindex="11"
                                class="mr-md-3"
                                :loading="loading"
                                :disabled="localizador.length !== tamanhoLocalizador"
                                :color="$config.dados.corprimaria"
                                @click="getVaucher()"
                                block
                                elevation="0"
                                style="color: white"
                            >
                                <strong>{{ $t_("proximo") }}</strong>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
    </Layout>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mask } from "vue-the-mask";
import Util from "@/controllers/Util.controller.js";

const TIMEOUT_RECAPTCHA = 30000;
const VALIDADE_PENDENTE = 10 * 60 * 1000;
const ESPERA_SESSAO = 15000;

export default {
    name: "Voucher",
    components: {
        Layout: () => import("@/layout/Default.vue"),
        VueRecaptcha,
    },
    directives: { mask },
    data() {
        return {
            localizador: "",
            tamanhoLocalizador: 16,
            loading: false,
            recaptchaPronto: false,
            resolveRecaptcha: null,
            timeoutRecaptcha: null,
            continuarAposLogin: false,
            intervaloSessao: null,
        };
    },
    methods: {
        getLocalizador() {
            const salvo = this.$axios.getLocal("voucher_localizador");
            const pendente = salvo && salvo.data && salvo.data.localizador;
            const localizador = this.$route.params.localizador || this.$route.query.loc || pendente;

            if (localizador) {
                this.localizador = String(localizador)
                    .toUpperCase()
                    .replace(/[^A-Z0-9]/g, "")
                    .substring(0, this.tamanhoLocalizador);
            }

            // Não remove aqui: o login social recarrega a tela antes de a sessão existir
            this.continuarAposLogin =
                !!pendente && this.localizador === pendente && Date.now() - salvo.data.em < VALIDADE_PENDENTE;

            if (salvo && !this.continuarAposLogin) {
                this.$axios.remove("voucher_localizador");
            }
        },
        regraLocalizador(v) {
            return (v && v.length === this.tamanhoLocalizador) || this.$t_("LOCALIZADOR_TAMANHO");
        },
        recaptchaAtivo() {
            return this.$config.conf.recaptcha_ativo && this.$config.conf.site_key_recaptcha;
        },
        onRecaptchaRender() {
            this.recaptchaPronto = true;
            this.continuarTroca();
        },
        continuarTroca() {
            if (!this.continuarAposLogin || !this.$axios.getLocal("session") || !this.$config.conf) {
                return;
            }

            if (this.recaptchaAtivo() && !this.recaptchaPronto) {
                return;
            }

            this.continuarAposLogin = false;
            clearInterval(this.intervaloSessao);
            this.$axios.remove("voucher_localizador");
            this.getVaucher();
        },
        aguardarSessao() {
            const inicio = Date.now();

            this.intervaloSessao = setInterval(() => {
                if (this.continuarAposLogin && Date.now() - inicio > ESPERA_SESSAO) {
                    this.continuarAposLogin = false;
                    this.$axios.remove("voucher_localizador");
                }

                if (!this.continuarAposLogin) {
                    clearInterval(this.intervaloSessao);
                    return;
                }

                this.continuarTroca();
            }, 500);
        },
        // Gera um token novo a cada tentativa (o token é de uso único e expira em 2 min)
        obterRecaptcha() {
            const widget = this.$refs.recaptcha;

            if (!widget || !this.recaptchaPronto) {
                return Promise.resolve("");
            }

            return new Promise((resolve) => {
                this.resolveRecaptcha = resolve;
                // Fechar o desafio de imagens não dispara nenhum callback
                this.timeoutRecaptcha = setTimeout(() => this.onRecaptchaVerify(""), TIMEOUT_RECAPTCHA);
                widget.reset();
                widget.execute();
            });
        },
        onRecaptchaVerify(token) {
            clearTimeout(this.timeoutRecaptcha);

            if (this.resolveRecaptcha) {
                this.resolveRecaptcha(token || "");
                this.resolveRecaptcha = null;
            }
        },
        async getVaucher() {
            if (this.loading) {
                return;
            }

            if (this.localizador.length !== this.tamanhoLocalizador) {
                this.$config.alertWarn(this.$t_("LOCALIZADOR_TAMANHO"));
                return;
            }

            if (!this.$axios.getLocal("session")) {
                this.$axios.setLocal("voucher_localizador", { localizador: this.localizador, em: Date.now() });
                this.$usuario.getLogins(window.location.origin + window.location.pathname);
                this.$usuario.showModalLogin = true;
                return;
            }

            this.loading = true;

            try {
                let recaptcha = "";

                if (this.recaptchaAtivo()) {
                    recaptcha = await this.obterRecaptcha();

                    if (!recaptcha) {
                        this.$config.alertWarn(this.$t_("recaptcha_invalido"));
                        return;
                    }
                }

                const response = await this.$superingresso.trocarVoucher(this.localizador, recaptcha);

                if (response && response.sucesso) {
                    new Util().snackbar(this.$t_("VOUCHER_TROCADO_SUCESSO"), "success");

                    if (response.reserva) {
                        await this.$carrinho.atualizaCarrinho();
                        this.$axios.rota("Checkout");
                    } else {
                        this.$axios.rota("MeusPedidos");
                    }
                    return;
                }

                // Erros da API já são exibidos pelo $axios.post; aqui só cobre sucesso == false
                if (response) {
                    this.$config.alertWarn(this.$t_("ALERTA_VOUCHE"));
                }
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.getLocalizador();

        if (this.continuarAposLogin) {
            this.aguardarSessao();
        }
    },
    beforeDestroy() {
        clearTimeout(this.timeoutRecaptcha);
        clearInterval(this.intervaloSessao);
    },
};
</script>
